
export const moduleName = `fbtSummary`